import VicaEDAREnConst from "../../../vica/VicaEDAREnConst";
import VicaEDARGestAyt from "../../../vica/VicaEDARGestAyt";
import VicaEDARGestIAA from "../../../vica/VicaEDARGestIAA";
import VicaEDARSubvIAA from "../../../vica/VicaEDARSubvIAA";
import VicaBalsas from "../../../vica/VicaBalsas";

import VicaFormsDemo001 from "../../../vica/VicaFormsDemo001";

export class CustomForms {

    constructor(results, mapLayer, sublayer, currentTabsResult, setCurrenTabsResult, setGeometry, setGeometryType) {
        this.results = results;
        this.mapLayer = mapLayer;
        this.sublayer = sublayer;
        this.currentTabsResult = currentTabsResult;
        this.setCurrenTabsResult = setCurrenTabsResult;
        this.setGeometry = setGeometry;
        this.setGeometryType = setGeometryType;

    }

    /**
     * TODO
     * 
     * Falta por crear la CustomForm de las Edar en construccion subencionadas
     */

    customFormsLayers = [
        "EDAR: EDARs gestionadas por el IAA en servicio", 
        "EDAR: EDARs subvencionadas por el IAA en servicio", 
        "EDAR: EDARs gestionadas por Ayuntamientos en servicio", 
        "EDAR: EDARs en construcción",
        "EDAR: Balsas",
        "Infraestructuras: Balsas",
    ];

    isBalsasLayer() {
        const key = this.mapLayer.name + ": " + this.sublayer.title;
        return this.customFormsLayers.includes(key)
            || /balsa/i.test(this.sublayer.title);
    }

    hasCustomForm() {
        return this.customFormsLayers.includes(this.mapLayer.name + ": " + this.sublayer.title)
            || this.isBalsasLayer();
    }

    renderForm = (mapView, table, mapLayer, sublayer) => {
        //console.log('entraaaaaa')
        this.setGeometry(this.results[0].feature.geometry)
        this.setGeometryType(this.results[0].feature.geometry.type)

       if ((this.mapLayer.name + ": " + this.sublayer.title) == "EDAR: EDARs gestionadas por el IAA en servicio") {
            return <VicaEDARGestIAA results={this.results}
                mapView={mapView} table={table} mapLayer={this.mapLayer} sublayer={this.sublayer}
                currentTabsResult={this.currentTabsResult} setCurrenTabsResult={this.setCurrenTabsResult}></VicaEDARGestIAA>
        }
        else if ((this.mapLayer.name + ": " + this.sublayer.title) == "EDAR: EDARs subvencionadas por el IAA en servicio") {
            return <VicaEDARSubvIAA results={this.results}
                mapView={mapView} table={table} mapLayer={this.mapLayer} sublayer={this.sublayer}
                currentTabsResult={this.currentTabsResult} setCurrenTabsResult={this.setCurrenTabsResult}></VicaEDARSubvIAA>
        }
        else if ((this.mapLayer.name + ": " + this.sublayer.title) == "EDAR: EDARs gestionadas por Ayuntamientos en servicio") {
            return <VicaEDARGestAyt results={this.results}
                mapView={mapView} table={table} mapLayer={this.mapLayer} sublayer={this.sublayer}
                currentTabsResult={this.currentTabsResult} setCurrenTabsResult={this.setCurrenTabsResult}></VicaEDARGestAyt>
        }
        else if ((this.mapLayer.name + ": " + this.sublayer.title) == "EDAR: EDARs en construcción") {
            return <VicaEDAREnConst results={this.results}
                mapView={mapView} table={table} mapLayer={this.mapLayer} sublayer={this.sublayer}
                currentTabsResult={this.currentTabsResult} setCurrenTabsResult={this.setCurrenTabsResult}></VicaEDAREnConst>
        }
        else if (this.isBalsasLayer()) {
            return <VicaBalsas results={this.results}
                mapView={mapView} table={table} mapLayer={this.mapLayer} sublayer={this.sublayer}
                currentTabsResult={this.currentTabsResult} setCurrenTabsResult={this.setCurrenTabsResult}></VicaBalsas>
        }
    };
}